import type { MergeBuffer, MergeBufferItem } from './types';


export default function createMergeDiffBuffer(): MergeBuffer {
  const changes: MergeBufferItem[] = [];

  return {
    append: entry => {
      const arr = Array.isArray(entry) ? entry : [entry];
      arr.forEach(entryToAppend => changes.push(entryToAppend));
    },
    package: () => changes,
  };
}
